import { useCallback, useEffect, useState } from "react"
import { NimbleEmoji } from "emoji-mart"
import data from "emoji-mart/data/twitter.json"
import useOnClickOutside from "react-cool-onclickoutside"
import Label from "@/components/common/forms/Label"
import EmojiPickerField from "@/components/common/forms/formik/EmojiPickerField"
import { styled, keyframes } from "@/styles/theme"
import classNames from "classnames"
import fieldStyles from "@/styles/Fields.module.scss"
import { useField } from "formik"

const slideDownAndFade = keyframes({
  "0%": { opacity: 0, transform: "translateY(-2px)" },
  "100%": { opacity: 1, transform: "translateY(0)" },
})

export default function CustomFieldFormEmojiPicker(props) {
  const [field, _meta, helpers] = useField(props)
  const { name, icon, anchor } = props

  const PickerWrapper = styled("div", {
    position: "absolute",
    backgroundColor: "$white",
    zIndex: 9999,
    boxShadow: "$8dp",
    top: "100%",
    ...(anchor === "right" && { right: 0 }),
    ...(anchor === "left" && { left: 0 }),
    animationDuration: "200ms",
    animationTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
    willChange: "transform, opacity",
    variants: {
      isPickerOpen: {
        true: { animationName: slideDownAndFade },
      },
    },
  })

  const [isPickerOpen, setIsPickerOpen] = useState(false)

  const clearOrOpenPicker = useCallback(() => {
    if (field.value) {
      helpers.setValue("")
    } else {
      setIsPickerOpen(true)
    }
  })

  const ref = useOnClickOutside(() => {
    setIsPickerOpen(false)
  })

  useEffect(() => {
    setIsPickerOpen(false)
  }, [icon])

  return (
    <div>
      <div>
        <Label>Icon</Label>
      </div>
      <div
        className={classNames(
          fieldStyles.cfEmojiPseudoDropdown,
          field.value && fieldStyles.hasValue
        )}
        ref={ref}
        onClick={clearOrOpenPicker}
      >
        {isPickerOpen && (
          <PickerWrapper isPickerOpen={isPickerOpen}>
            <EmojiPickerField name={name} />
          </PickerWrapper>
        )}

        <NimbleEmoji emoji={icon || ""} set="twitter" data={data} size={20} />
      </div>
    </div>
  )
}
